'use strict';/* global define:false */define('helen/models/feedback',['./base-model'],function(base){'use strict';var paramDefaults={id:'@id'};return base('feedback/:type/:param/:id/:userId',paramDefaults);});
